<!-- Login Page -->
<ng-container *ngIf="location == '/' || location == ''">

    <router-outlet></router-outlet>

</ng-container>

<!-- All Other Pages -->
<ng-container *ngIf="!(location == '/' || location == '')">

    <app-sidebar></app-sidebar>

    <div [@routeAnimations]="prepareRoute(outlet)"
         class="main-content d-flex flex-column">

        <app-header></app-header>

        <router-outlet #outlet="outlet"></router-outlet>

        <div class="flex-grow-1"></div>

    </div>

    <p-confirmDialog
        header="Confirmation"
        icon="pi pi-exclamation-triangle">
    </p-confirmDialog>

</ng-container>

<div class="modal fade basicModal"
     id="small_Module"
     *ngIf="appservice.Req_Camera"
     data-backdrop="static"
     data-keyboard="false"
     role="dialog"
     aria-hidden="true">

    <div class="modal-dialog modal-dialog-centered modal" role="document">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title">
                    Update {{appservice.Cam_Type}}
                </h5>

                <button type="button"
                        class="close"
                        (click)="appservice.Close_Modal()">

                    <span>&times;</span>

                </button>

            </div>

            <div class="modal-body">

                <app-add-item></app-add-item>

            </div>

        </div>

    </div>

</div>